(function () {
    'use strict';

    function addUnderwritingNote(workflowStateService) {
        return {
            restrict: 'E',
            templateUrl: 'workflow/directives/templates/addUnderwritingNote.html',
            scope: {
                path: '=',
                onAdd: '&',
                sessionEntity: '=?',
                parentCollection: '='
            },
            link: function (scope, element, attrs) {
                scope.newNote = {};

                scope.addNote = function (form) {
                    var newNote = {
                        NoteId: uuid.v4(),
                        Note: scope.newNote.text,
                        Path: scope.path,
                        UpdatedDate: (new Date()).toISOString()
                    };
                    workflowStateService.saveUnderwritingNote(newNote);
                    scope.parentCollection.push(newNote);
                    form.$setPristine();
                    scope.newNote = {};
                };
            }
        };
    }

    addUnderwritingNote.$inject = ['workflowStateService'];

    angular.module('ecap.workflow').directive('addUnderwritingNote', addUnderwritingNote);
})();

